import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DraggableModal from "../../layout/DraggableModal/DraggableModal";
import Input from "../../utils/Input/Input";

const HitPoints = ({ hp, hitDice = [], onChange }) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [isMaxHpOpen, setIsMaxHpOpen] = useState(false);
  const [maxHpDraft, setMaxHpDraft] = useState("");
  const maxHpInputRef = useRef(null);
  const currentHP = Number(hp.currentHP) || 0;
  const maxHP = Number(hp.maxHP) || 0;
  const changeHp = (direction) => {
    const amount = Number(inputValue) || 0;
    onChange({ ...hp, currentHP: Math.min(maxHP, Math.max(0, currentHP + direction * amount)) });
    setInputValue("");
  };

  const openMaxHp = () => {
    setMaxHpDraft(String(maxHP));
    setIsMaxHpOpen(true);
  };

  const saveMaxHp = (event) => {
    event.preventDefault();
    const nextMaxHP = Math.max(0, Number(maxHpDraft) || 0);
    onChange({ ...hp, maxHP: nextMaxHP, currentHP: Math.min(currentHP, nextMaxHP) });
    setIsMaxHpOpen(false);
  };

  return (
    <div className="hit-points-container">
      <div className="buttons-input-column">
        <button type="button" onClick={() => changeHp(1)} className="heal-button">{t("sheet.heal")}</button>
        <Input ariaLabel={t("sheet.hpChangeAmount")} id="hp-change" name="hp-change" type="number" value={inputValue} className="damage-input" onChange={(event) => setInputValue(event.target.value)} />
        <button type="button" onClick={() => changeHp(-1)} className="damage-button">{t("sheet.damage")}</button>
      </div>
      <div className="hp-display-column">
        <strong>{t("sheet.hitPoints")}</strong>
        <div className="hp-value-row">
          <div className="current-hp">{currentHP} / {maxHP}</div>
          <button
            aria-label={t("sheet.editMaximumHitPoints")}
            className="edit-max-hp-button"
            title={t("sheet.editMaximumHitPoints")}
            type="button"
            onClick={openMaxHp}
          >
            <span aria-hidden="true">&#8943;</span>
          </button>
        </div>
        {hitDice.length > 0 && (
          <div className="hit-dice">
            <strong>{t("sheet.hitDice")}:</strong>{" "}
            {hitDice.map(({ die }) => `d${die}`).join(", ")}
          </div>
        )}
      </div>
      <DraggableModal
        headerText={t("sheet.editMaximumHitPoints")}
        initialFocusRef={maxHpInputRef}
        isVisible={isMaxHpOpen}
        onClose={() => setIsMaxHpOpen(false)}
      >
        <form className="max-hp-form" onSubmit={saveMaxHp}>
          <label htmlFor="max-hp">{t("sheet.maximumHitPoints")}</label>
          <input
            id="max-hp"
            min="0"
            name="max-hp"
            ref={maxHpInputRef}
            type="number"
            value={maxHpDraft}
            onChange={(event) => setMaxHpDraft(event.target.value)}
          />
          <div className="max-hp-form-actions">
            <button type="button" onClick={() => setIsMaxHpOpen(false)}>{t("common.cancel")}</button>
            <button type="submit">{t("common.save")}</button>
          </div>
        </form>
      </DraggableModal>
    </div>
  );
};

export default HitPoints;
